module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-light.01e92b1e.ttf";